module.exports = __webpack_public_path__ + "img/entry.e6276afa.png";